import { AxiosResponse } from 'axios';

import { Headers, HttpClient } from '../utils';

export const REFRESH_TOKEN_URL = '/idp/login?redirect=false';

export const refreshAccessToken = (): Promise<AxiosResponse> => {
  const headers = { Accept: 'text/html' } as Headers;

  return HttpClient.getRaw(REFRESH_TOKEN_URL, {}, headers, 'document');
};
